import { OverflowedText } from '@/utilities/overflowedText';
import { Tooltip, Flex } from '@chakra-ui/react';
import { memo, useState } from 'react';
import { EApplicantOfferPGKeys } from 'api-paths-cas';
import { TableCellProps } from '../../../types';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const LeftAlignFormatter = memo(function formatter(cellProps: TableCellProps) {
  const courseName = cellProps.row?.programme?.courseName || cellProps.row?.courseName || UNKNOWN_VALUE;
  const courseId = cellProps.row?.programme?.courseId || cellProps.row?.courseId || UNKNOWN_VALUE;

  const showTooltip = courseName !== UNKNOWN_VALUE && courseId !== UNKNOWN_VALUE;
  const tooltip = `${courseName}: ${courseId}`;

  const [isOverflowed, setIsOverflowed] = useState(false);
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      <Tooltip hasArrow placement="top" label={tooltip} isDisabled={!showTooltip && isOverflowed}>
        <div>
          <OverflowedText
            overflowedHandler={setIsOverflowed}
            theme={{
              lines: 2,
            }}
          >
            {courseName}
          </OverflowedText>
        </div>
      </Tooltip>
    </Flex>
  );
});

export const CourseColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.COURSE_ID,
    name: 'Course',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(160px, 1.75fr)',
    formatter: LeftAlignFormatter,
    responsive: true,
  },
  visible: () => true,
});
